export enum MembershipTypeNames {
  basic = "basic",
  pro = "pro",
  premium = "premium",
}

export interface MembershipType {
  id: number;
  name: MembershipTypeNames;
  description: string | null;
  price: number;
  duration: number;
  stripe_product_id: string | null;
  stripe_price_id: string | null;
}
